import React from "react";
import { DeleteGuide, GetGuides, GuideViewModel } from "./GuideStore";
import OrganizationContextSwitcher from "../organizations/ContextSwitcher";
import { Button, Table } from "reactstrap";
import { Link } from "react-router-dom";

const GuidesIndex = () => {
    const [guides, setGuides] = React.useState([] as GuideViewModel[]);

    React.useEffect(() => {
        GetGuides("").then((res) => setGuides(res.value));
    }, []);

    const deleteGuide = async (id: string) => {
        await DeleteGuide(id);
        GetGuides("").then((res) => setGuides(res.value));
    };

    return (
        <div>
            <OrganizationContextSwitcher></OrganizationContextSwitcher>
            <h3>Guides</h3>
            <Link to="/guides/create">Create Guide</Link>
            <Table>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Organization</th>
                        <th>Key</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {guides.map((guide) => (
                        <tr key={guide.id}>
                            <td>
                                <div>{guide.thumbnailURI && <img src={guide.thumbnailURI} width={"200px"}></img>}</div>
                                <div>{guide.name}</div>
                            </td>
                            <td>{guide.organizationID}</td>
                            <td>{guide.key}</td>
                            <td>
                                <a href={guide.guideURI} target="_blank">
                                    View
                                </a>
                            </td>
                            <td style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                <Link to={`/guides/${guide.id}`}>Edit</Link>
                                <Button color="danger" onClick={() => deleteGuide(guide.id)}>
                                    Delete
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default GuidesIndex;
